import Http from "./../http";

export default {
  // 获取底纹
  getShading(params, callback) {
    Http.get("/elasticSearch/searchBackground", params, (res) => {
      callback(res);
    });
  },
  // 记录搜索次数
  getSearchNum(params, callback) {
    Http.get("/elasticSearch/saveNum", params, (res) => {
      callback(res);
    });
  },
  // 搜索结果+搜索热词
  getSearch(type, params, callback) {
    let url = type == 'powderedMilk' ? "milkPowderSearch/searchHot" : "/elasticSearch/" + type;
    Http.get(url, params, (res) => {
      callback(res);
    })
  },
  // 接口改造，全局搜索
  getCommonSearch(type, params, callback) {
    let url = "/content/search" + (type === 'allSearch' ? "/allSearch" : "/listByKeyword");
    Http.post(url, {}, params, (res) => {
      callback(res);
    }, () => { }, 'lucky')
  }
};
